import { Box } from '@mui/material'
import { COLORS } from '../../constants'

function Tag({ text, tone = 'light' }: { text: string, tone?: 'dark' | 'light' }) {
    const dark = tone === 'dark'
    return (
        <Box
            component="span"
            sx={{
                display: 'inline-block', px: 1.25, py: 0.5, borderRadius: 1.5, fontSize: '0.85rem', fontWeight: 500,
                backgroundColor: dark ? COLORS.blackSecondary : COLORS.light,
                border: `1px solid ${dark ? COLORS.blackBorder : COLORS.border}`,
                color: dark ? COLORS.white : COLORS.black,
            }}
        >
            {text}
        </Box>
    )
}

export default Tag
